import Authorized from '../../components/Authorization/Authorized';
import { Menu, Popconfirm, Space } from 'antd';
import { DeleteOutlined, EditOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import React from 'react';
import momenth from 'moment-hijri';
import moment from 'moment';

export const rowStyle = {
  marginLeft: 20,
  marginRight: 20,
};

export const getOperationType = (id) => {
  if (id) {
    return {
      type: 'Update',
      method: 'PUT',
    };
  } else {
    return {
      type: 'Add',
      method: 'POST',
    };
  }
}

export const getTableMenuItems = (onMenuClick, handleSingleDelete) =>  {
  return (
    <div>
      <Authorized asset="item" operation="write">
        <Menu onClick={onMenuClick}>
          <Menu.Item key="edit">
            <Space direction="horizontal">
              <EditOutlined />
              Update
            </Space>
          </Menu.Item>
          <Menu.Item key="delete">
            <Popconfirm
              title="Sure to delete?"
              placement="left"
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={handleSingleDelete}
            >
              <Space direction="horizontal">
                <DeleteOutlined />
                Delete
              </Space>
            </Popconfirm>
          </Menu.Item>
        </Menu>
      </Authorized>
    </div>
  )
}
moment.locale('en');

export const pageSizeOptions = [
  '10',
  '20',
  '30',
  '40',
  '50',
  '100',
  '200',
  '500',
  '1000',
]

export const getHijriYear = gregorian => {
  return momenth(gregorian, 'YYYY-MM-DDTHH:mm:ss.SSSSZ')
    .locale('en')
    .format('iYYYY/iM/iD')
}

export const downloadBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(
    new Blob([blob]),
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    fileName,
  );

  // Append to html link element page
  document.body.appendChild(link);

  // Start download
  link.click();

  // Clean up and remove the link
  link.parentNode.removeChild(link);
}
